import * as request from 'superagent';
import constants from "./constants.js";

function post(url, params, cb = constants.emptyFnc) {
  request
    .post(url)
    .send(params)
    .end((err, res) => {
      if (err || !res.ok) return cb(res.body);

      cb(null, res.body);
    });
}

function get(url, query, cb = constants.emptyFnc) {
  request
    .get(url)
    .query(query)
    .end((err, res) => {
      if (err || !res.ok) return cb(res.body);

      cb(null, res.body);
    });
}

function put(url, params, cb = constants.emptyFnc) {
  request
    .put(url)
    .send(params)
    .end((err, res) => {
      if (err || !res.ok) return cb(res.body);

      cb(null, res.body);

    });
}

function remove(url, params, cb = constants.emptyFnc) {
  request
    .delete(url)
    .send(params)
    .end((err, res) => {
      if (err || !res.ok) return cb(res.body);

      cb(null, res.body);

    });
}

export {
  post,
  get,
  put,
  remove as delete,
};